module.exports = __webpack_public_path__ + "img/logo-header-white.128b776b.png";